<template>
  <b-modal
      :visible="visible"
      title="Please confirm"
      ok-variant="success"
      @hidden="$emit('cancel')"
      @ok="onClickApprove"
      hide-header-close
      centered
  >
    <p>You are going to resync <strong>{{ polling }}</strong> for this facility</p>
    <strong v-if="license">{{ `${license.facility.name} - ${license.number}` }}</strong>
    <hr>
    <b-form-group label="Number of days to re-sync">
      <b-form-input
          v-model.trim="days"
          type="number"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: "AdminLicenseResyncModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    license: Object,
    polling: String,
  },
  data() {
    return {
      days: 1000
    }
  },
  methods: {
    onClickApprove() {
      this.$emit('approve', this.days);
    }
  }
}
</script>
